import { useEffect, useRef } from 'react'
import axios from 'axios'

interface FormUsageParams {
	folder: string
	model: string
	dashboard?: any
	filter?: any | null
}

const loggedModels = new Set<string>()

export function useFormUsage({ folder, model, dashboard, filter }: FormUsageParams) {
	const timerRef = useRef<NodeJS.Timeout | null>(null)
	const hasLoggedRef = useRef<boolean>(false)
	const modelKey = `${folder}/${model}`

	useEffect(() => {
		if (loggedModels.has(modelKey)) {
			return
		}

		hasLoggedRef.current = false

		timerRef.current = setTimeout(() => {
			if (!hasLoggedRef.current && !loggedModels.has(modelKey)) {
				hasLoggedRef.current = true
				loggedModels.add(modelKey)
				logFormUsage(folder, model, dashboard, filter)
			}
		}, 5000)

		return () => {
			if (timerRef.current) {
				clearTimeout(timerRef.current)
			}
		}
	}, [folder, model, modelKey, dashboard, filter])

	const logFormUsage = async (folder: string, model: string, dashboard?: boolean, filter?: string) => {
		try {
			await axios.post(`${API_FIBER_URL}/forms/usage`, {
				folder,
				model,
				dashboard,
				filter,
			})
			console.log(`Form usage logged for ${folder}/${model}`)
		} catch (error) {
			console.error('Error logging form usage:', error)
		}
	}

	return {
		logFormUsage: () => {
			if (!hasLoggedRef.current && !loggedModels.has(modelKey)) {
				hasLoggedRef.current = true
				loggedModels.add(modelKey)
				logFormUsage(folder, model, dashboard, filter)
			}
		},
	}
}
